import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getSubgroupsPhyto.success: {
            return action.payload;
        }

        case constants.getSubgroupsPhyto.error: {
            return initialState;
        }

        case constants.getSubgroupsPhyto.try: {
            return {};
        }

        default:
            return state;
    }
}